import { render, staticRenderFns } from "./ServiceCenterItem.vue?vue&type=template&id=77d37a74&"
import script from "./ServiceCenterItem.controller.js?vue&type=script&lang=js&"
export * from "./ServiceCenterItem.controller.js?vue&type=script&lang=js&"
import style0 from "./ServiceCenterItem.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports